'use es6';

import getIn from 'transmute/getIn';
import { EMAIL, FIRST_NAME, ID, IS_FREE_USER, LAST_NAME } from '../constants/keyPaths';
export const getEmail = getIn(EMAIL);
export const getFirstName = getIn(FIRST_NAME);
export const getLastName = getIn(LAST_NAME);
export const getId = getIn(ID);
export const getIsFreeUser = getIn(IS_FREE_USER);